export const TEST_ID = 'batteryStatusControl';

export const DEFAULT_LIFECYCLE_STATUS = 'in-service' as const;
